import React, { useEffect, useState } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

import FiltroEstados from "./FiltroEstados";
import CrearEstado from "./CrearEstado";
import VerEstado from "./VerEstado";
import EditarEstado from "./EditarEstado";
import EliminarEstado from "./EliminarEstado";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarEstados() {
  // === ESTADO ===
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false); // Agregamos estado de carga

  const [porPagina, setPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);

  const [filters, setFilters] = useState({ descripcion: "", tipoId: "" });

  // Modales
  const [showFiltro, setShowFiltro] = useState(false);
  const [showCrear, setShowCrear] = useState(false);
  const [showVerEstado, setShowVerEstado] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [showEliminar, setShowEliminar] = useState(false);

  // Selecciones
  const [estadoId, setEstadoId] = useState(null);
  const [estadoAEliminar, setEstadoAEliminar] = useState(null);
  
  const [reloadKey, setReloadKey] = useState(0);

  const totalPaginas = Math.ceil(total / porPagina);

  // === Cargar datos desde la API ===
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const url = apiRoutes.estado.listUrl({
          page: pagina - 1,
          size: porPagina,
          q: filters.descripcion ?? "",
          tipoId: filters.tipoId,
        });

        const data = await appFetchJson(url);

        setItems(
          (data?.items || data?.content || []).map((x) => ({
            id: x.id,
            descripcion: x.nombre, // ESTA_NM_ESTADO
            tipo: x.tipoNombre,    // ESTI_NM_TIPOESTADO
          })),
        );

        setTotal(data?.totalElements ?? data?.pagination?.total ?? 0);
      } catch (err) {
        console.error("Error cargando estados:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [pagina, porPagina, filters, reloadKey]);

  const cambiarPagina = (num) => {
    if (num < 1) num = 1;
    if (num > totalPaginas) num = totalPaginas;
    setPagina(num);
  };

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (TOTAL 100%)
  // ====================================================================
  const columns = [
    // 1. DESCRIPCIÓN (40%)
    { 
      header: "Descripción", 
      accessor: "descripcion",
      type: "text", 
      width: "40%", 
      cellClass: "font-medium text-gray-800 break-words" 
    },
    // 2. ESTADO TIPO (40%)
    { 
      header: "Estado Tipo", 
      accessor: "tipo",
      type: "text", 
      width: "40%", 
      cellClass: "text-gray-600 break-words"
    },
    // 3. ACCIÓN (20%)
    {
      header: "Acción",
      type: "action", 
      width: "20%",
      render: (item) => (
        <div className="flex justify-center items-center gap-2">
          <button
            className="text-gray-500 hover:text-blue-600 p-1"
            title="Editar"
            onClick={() => {
              setEstadoId(item.id);
              setShowEditar(true);
            }}
          >
            <FaEdit />
          </button>

          <button
            className="text-gray-500 hover:text-red-600 p-1"
            title="Eliminar"
            onClick={() => {
              setEstadoAEliminar(item);
              setShowEliminar(true);
            }}
          >
            <FaTrashAlt />
          </button>
        </div>
      )
    }
  ];

  // ================================
  //   RENDER
  // ================================
  return (
    <div className="page">

      <ListHeader
        title="Estados"
        onFilterClick={() => setShowFiltro(true)}
        filters={filters}
        onClearFilters={() => {
  setFilters({ descripcion: "", tipoId: "" });
  setPagina(1);
}}
        showAdd
        addLabel="Agregar"
        onAddClick={() => setShowCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-4 text-center text-gray-500">Cargando datos...</div>}

      {/* === TABLA DINÁMICA === */}
      {!loading && (
        <DynamicTable 
          size="S" // 3 Columnas -> Breakpoint 768px (Ideal para tablets y escritorio)
          data={items}
          columns={columns}
        />
      )}

      {/* Filtros */}
      {showFiltro && (
        <FiltroEstados
          initialFilters={filters}
          onSubmit={(nuevosFiltros) => {
  setFilters(nuevosFiltros);
  setPagina(1);
  setShowFiltro(false);
}}
          onClose={() => setShowFiltro(false)}
        />
      )}

      {/* Crear */}
      {showCrear && (
        <CrearEstado
          onClose={() => setShowCrear(false)}
          onCreated={() => {
            setPagina(1);
            setReloadKey((k) => k + 1);
            setShowCrear(false);
          }}
        />
      )}

      {/* Ver */}
      {showVerEstado && (
        <VerEstado id={estadoId} onClose={() => setShowVerEstado(false)} />
      )}

      {/* Editar */}
      {showEditar && (
        <EditarEstado
          id={estadoId}
          onClose={() => setShowEditar(false)}
          onSaved={() => {
            setReloadKey((k) => k + 1);
            setShowEditar(false);
          }}
        />
      )}

      {/* Eliminar */}
      {showEliminar && (
        <div className="modal-backdrop" onClick={() => setShowEliminar(false)}>
          <div
            className="modal-panel-lg no-x"
            onClick={(e) => e.stopPropagation()}
          >
            <EliminarEstado
              registro={estadoAEliminar}
              onClose={() => setShowEliminar(false)}
              onDeleted={(registroEliminado) => {
                setItems((prev) =>
                  prev.filter((it) => it.id !== registroEliminado.id),
                );
                setTotal((t) => Math.max(0, t - 1));
                setShowEliminar(false);
              }}
            />
          </div>
        </div>
      )}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={total}
        onPageChange={cambiarPagina}
      />
    </div>
  );
}